import { ScreenBankEntityTypes } from "./types"

export const ScreenTypeToCollectionMapping: Record<
  ScreenBankEntityTypes,
  "seq_qti_screens" | "seq_passages"
> = {
  question: "seq_qti_screens",
  passage: "seq_passages"
}
